import Fuse from "fuse.js";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import BackgroundOverlay from "../../framework/BackgroundOverlay";
import GlobalContext from "../../framework/GlobalContext";
import TextInput from "../../framework/TextInput";

import { SUPPORT_CONTACT1, SUPPORT_EMAIL1 } from "../../utils/constant";

import spotlightIcons from "../../assets/images/spotlight";

import { InputAdornment } from "@mui/material";
import { debounce } from "lodash";
import images from "../../assets/images";
import {
  ADD_SERVICE_ITEM_TAB,
  ADD_SYSTEM_TAB,
  BANK_TAB,
  BRANCH_GROUP_TAB,
  CAC_USER_TAB,
  CUSTOMER_TAB,
  DISCOUNT_PROGRAM_TAB,
  DISTRIBUTOR_TAB,
  DOCTORS_TAB,
  ENTITY_TAB,
  GENERATE_OTP_TAB,
  HEALTH_STATUS_TAB,
  HSN_TAB,
  MANUFACTURER_GROUP_TAB,
  MANUFACTURER_TAB,
  PRODUCTS_TAB,
  PROFESSION_TAB,
  REPORTS_DISCOUNT_PROGRAM,
  REPORTS_DISCOUNT_SLAB,
  REPORTS_FREQUENCY_SLAB_TAB,
  REPORTS_MEDICINE_WISE_STOCK_AUDIT,
  REPORTS_MEDICINE_WISE_STOCK_REQUEST,
  REPORTS_MEDICINE_WISE_STOCK_TRANSFER,
  REPORTS_STOCK_AUDIT,
  REPORTS_STOCK_REQUEST,
  REPORTS_STOCK_TRANSFER,
  RETAILER_REPORTS_TAB,
  ROLES_TAB,
  SPECIALITY_TAB,
  STOCK_AUDIT_TAB,
  TRANSPORTATION_TAB,
  USERS_TAB,
  DOCTOR_COMMISSION_TAB,
  REPORTS_DOCTOR_COMMISSION_PROGRAM,
  REPORTS_MODE_CONFIG_PRICING,
} from "../../framework/tab/tabUtilsConstants";
import { formatNumber, getStringValue } from "../../utils/utils";
import Menu from "./Menu";
import classes from "./Spotlight.module.css";

const Spotlight = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [evaluatedString, setEvaluatedString] = useState(null);
  const [searchResult, setSearchResult] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const spotlightSearchInputRef = useRef();
  const listRef = useRef(null);
  const { searchIcon } = images;
  const {
    showSpotlight,
    currentComponent,
    setCurrentComponent,
    setShowSpotlight,
    setAddNewTab,
    showAddProductAutocomplete,
  } = useContext(GlobalContext);
  const search_screens = useMemo(() => {
    return [
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Users",
        search: "users",
        action: () => setAddNewTab({ component: USERS_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Products Master",
        search: "productsmaster",
        action: () => setAddNewTab({ component: PRODUCTS_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Doctor Master",
        search: "doctormaster",
        action: () => setAddNewTab({ component: DOCTORS_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "HSN Master",
        search: "hsn",
        action: () => setAddNewTab({ component: HSN_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Distributor Master",
        search: "distributormaster",
        action: () => setAddNewTab({ component: DISTRIBUTOR_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Entity/Family Master",
        search: "entitymaster",
        action: () => setAddNewTab({ component: ENTITY_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Customer Master",
        search: "customermaster",
        action: () => setAddNewTab({ component: CUSTOMER_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Bank Master",
        search: "bankmaster",
        action: () => setAddNewTab({ component: BANK_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Transport Master",
        search: "transportmaster",
        action: () => setAddNewTab({ component: TRANSPORTATION_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Roles",
        search: "roles",
        action: () => setAddNewTab({ component: ROLES_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Retailer",
        search: "retailer",
        action: () => setAddNewTab({ component: RETAILER_REPORTS_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.moreIcon,
        title: "Generate OTP",
        search: "generateotp",
        action: () => setAddNewTab({ component: GENERATE_OTP_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.doctorActiveIcon,
        title: "Health Status",
        search: "healthstatus",
        action: () => setAddNewTab({ component: HEALTH_STATUS_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.doctorActiveIcon,
        title: "System",
        search: "system",
        action: () => setAddNewTab({ component: ADD_SYSTEM_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Stock Audit",
        search: "stockaudit",
        action: () => setAddNewTab({ component: STOCK_AUDIT_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Stock Audit Report",
        search: "stockauditreport",
        action: () => setAddNewTab({ component: REPORTS_STOCK_AUDIT }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Stock Transfer Report",
        search: "stocktransferreport",
        action: () => setAddNewTab({ component: REPORTS_STOCK_TRANSFER }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Stock Request Report",
        search: "stockrequestreport",
        action: () => setAddNewTab({ component: REPORTS_STOCK_REQUEST }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Medicine Wise Stock Audit Report",
        search: "medicinewisestockauditreport",
        action: () =>
          setAddNewTab({ component: REPORTS_MEDICINE_WISE_STOCK_AUDIT }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Discount Program Report",
        search: "discountprogramreport",
        action: () => setAddNewTab({ component: REPORTS_DISCOUNT_SLAB }),
      },
      // {
      //   type: "screen",
      //   menu_icon: spotlightIcons.reportsActiveIcon,
      //   title: "Discount Program Report",
      //   search: "discountprogramreport",
      //   action: () => setAddNewTab({ component: REPORTS_DISCOUNT_PROGRAM }),
      // },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Profession Master",
        search: "professionmaster",
        action: () => setAddNewTab({ component: PROFESSION_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Medicine Wise Stock Transfer Report",
        search: "medicinewisestocktransferreport",
        action: () =>
          setAddNewTab({ component: REPORTS_MEDICINE_WISE_STOCK_TRANSFER }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Medicine Wise Stock Request Report",
        search: "medicinewisestockrequestreport",
        action: () =>
          setAddNewTab({ component: REPORTS_MEDICINE_WISE_STOCK_REQUEST }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Service Item Master",
        search: "serviceitemmaster",
        action: () => setAddNewTab({ component: ADD_SERVICE_ITEM_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Manufacturer Master",
        search: "manufacturermaster",
        action: () => setAddNewTab({ component: MANUFACTURER_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Manufacturer Group Master",
        search: "manufacturergroupmaster",
        action: () => setAddNewTab({ component: MANUFACTURER_GROUP_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Branch Group Master",
        search: "branchgroupmaster",
        action: () => setAddNewTab({ component: BRANCH_GROUP_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Speciality Master",
        search: "specialitymaster",
        action: () => setAddNewTab({ component: SPECIALITY_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Frequency Slab Report",
        search: "frequencyslabreport",
        action: () => setAddNewTab({ component: REPORTS_FREQUENCY_SLAB_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "CAC Users",
        search: "cacuser",
        action: () => setAddNewTab({ component: CAC_USER_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Discount Program",
        search: "discountprogram",
        action: () => setAddNewTab({ component: DISCOUNT_PROGRAM_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Doctor Commission Program",
        search: "doctorcommissionprogram",
        action: () => setAddNewTab({ component: DOCTOR_COMMISSION_TAB }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Doctor Commission Program Report",
        search: "doctorcommissionprogramreport",
        action: () => setAddNewTab({ component: REPORTS_DOCTOR_COMMISSION_PROGRAM }),
      },
      {
        type: "screen",
        menu_icon: spotlightIcons.reportsActiveIcon,
        title: "Mode Config Pricing Report",
        search: "modeconfigpricingreport",
        action: () => setAddNewTab({ component: REPORTS_MODE_CONFIG_PRICING }),
      },
    ];
  }, [setAddNewTab]);

  const fetchSearchResults = useCallback(
    (searchTerm) => {
      const options = {
        shouldSort: true,
        findAllMatches: true,
        includeScore: true,
        threshold: 0.4,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ["title", "search"],
      };

      const fuse = new Fuse(search_screens, options);
      const fuse_result = fuse.search(searchTerm);
      let core_screen = [];
      let ugly_screen = [];
      fuse_result.forEach((r) => {
        const screen = {
          type: r.item.type,
          menu_icon: r.item.menu_icon,
          title: r.item.title,
          action: r.item.action,
        };
        if (r.score < 0.09 && searchTerm.length / r.item.search.length > 0.4) {
          core_screen.push(screen);
        } else {
          ugly_screen.push(screen);
        }
      });
      setSearchResult([...core_screen, ...ugly_screen]);
    },
    [search_screens]
  );
  const listClickHandler = useCallback(
    (index) => {
      setActiveIndex(index);
      const result = searchResult[index];
      if (result.type === "screen") {
        result.action();
        setShowSpotlight(false);
        return;
      }
    },
    [searchResult, setShowSpotlight]
  );

  const spotlightSearchHandler = useCallback(
    (e) => {
      setSearchTerm(e.target.value);
      if (e.target.value.length > 2) {
        let computedValue = null;
        try {
          // eslint-disable-next-line no-eval
          computedValue = eval(e.target.value);
          if (typeof computedValue === "number")
            setEvaluatedString(getStringValue(computedValue));
        } catch (e) {
          setEvaluatedString(null);
        }
        debounce(() => fetchSearchResults(e.target.value), 300)();
      } else {
        setEvaluatedString(null);
        setSearchTerm(null);
      }
    },
    [fetchSearchResults]
  );

  const spotlightSearchListener = useCallback(
    (e) => {
      const key = e.key.toLowerCase();
      if (key === "arrowdown") {
        if (activeIndex === searchResult.length - 1) {
          return;
        }
        setActiveIndex((prev) => prev + 1);
        // executeScroll(listRef);
        return;
      }
      if (key === "arrowup") {
        if (activeIndex === 0) {
          return;
        }
        setActiveIndex((prev) => prev - 1);
        // executeScroll(listRef);
        return;
      }
      if (key === "enter") {
        if (!searchResult?.length) {
          spotlightSearchInputRef.current?.click();
          return;
        }
        listClickHandler(activeIndex);
        return;
      }

      if (key === "escape") {
        setShowSpotlight(false);
        e.stopPropagation();
        return;
      }
    },
    [activeIndex, listClickHandler, searchResult.length, setShowSpotlight]
  );

  useEffect(() => {
    if (showSpotlight) {
      spotlightSearchInputRef.current.focus();
    }
  }, [showSpotlight]);

  useEffect(() => {
    setCurrentComponent("list_nav_spotlight_search_result");
    return () => {
      if (!showAddProductAutocomplete) {
        setCurrentComponent(null);
      }
    };
  }, [setCurrentComponent, showAddProductAutocomplete]);

  useEffect(() => {
    if (currentComponent === "list_nav_spotlight_search_result")
      document.addEventListener("keyup", spotlightSearchListener, false);
    return () => {
      document.removeEventListener("keyup", spotlightSearchListener, false);
    };
  });

  return (
    <>
      <div className={classes["spotlight-container"]}>
        <div className={classes["spotlight-content-container"]}>
          <div className={classes["spotlight-content"]}>
            <div className={classes["spotlight-searchbar"]}>
              <TextInput
                variant="standard"
                placeholder="Search here..."
                ref={spotlightSearchInputRef}
                onChange={spotlightSearchHandler}
                onKeyDown={(e) => {
                  const key = e.key.toLowerCase();
                  if (key === "tab") {
                    e.preventDefault();
                  }
                }}
                InputProps={{
                  // eslint-disable-next-line no-eval
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={searchIcon} alt="search" />
                    </InputAdornment>
                  ),
                  endAdornment: evaluatedString && (
                    <div
                      className={classes["computed-value"]}
                    >{`= ${formatNumber(evaluatedString, 0, true, "")}`}</div>
                  ),
                }}
              />
            </div>
            {searchTerm && (
              <div className={classes["spotlight-search-result-container"]}>
                <ul>
                  {searchResult?.map((result, index) => {
                    return (
                      <li
                        ref={index === activeIndex ? listRef : null}
                        key={index}
                        onClick={() => listClickHandler(index)}
                        className={`${
                          classes["spotlight-search-result-list-item"]
                        } ${index === activeIndex && classes["active"]}`}
                      >
                        <div
                          className={
                            classes["spotlight-search-result-list-item-content"]
                          }
                        >
                          <img
                            src={result.menu_icon}
                            alt={result.title}
                            width={24}
                            height={24}
                          />
                          <div
                            className={
                              classes["spotlight-search-result-title-container"]
                            }
                          >
                            <div
                              className={
                                classes["spotlight-search-result-title"]
                              }
                            >
                              {result.title}
                            </div>
                            <div
                              className={
                                classes["spotlight-search-result-subtitle"]
                              }
                            >
                              {result.subTitle}
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            {!searchTerm && (
              <div className={classes["spotlight-tabs-container"]}>
                <Menu />
              </div>
            )}
          </div>
          <div className={classes["spotlight-footer"]}>
            <div className={classes["footer-item"]}>
              <img src={spotlightIcons["callIcon"]} alt="Call Icon" />
              <div className={classes["footer-item-label"]}>
                {SUPPORT_CONTACT1}
              </div>
            </div>
            <div className={classes["footer-item"]}>
              <img src={spotlightIcons["whatsappIcon"]} alt="Chat Icon" />
              <div className={classes["footer-item-label"]}>
                {SUPPORT_CONTACT1}
              </div>
            </div>
            <div className={classes["footer-item"]}>
              <img src={spotlightIcons["gmailIcon"]} alt="Gmail Icon" />
              <div className={classes["footer-item-label"]}>
                {SUPPORT_EMAIL1}
              </div>
            </div>
          </div>
        </div>
      </div>
      <BackgroundOverlay defaultZIndex={999} />
    </>
  );
};

export default Spotlight;
